<template>
    <div class="position-relative celebration">
        <div class="position-absolute btn-close z-index-7">
            <v-btn icon color="primary" @click="closeQuestion">
                <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
            </v-btn>
        </div>
        <UtilsContent @close-action="closeQuestion" content-width="55" content-width-unit="vw">
            <template v-slot:header>
                <div class="row">
                    <v-app-bar
                        color="white"
                        dense
                        class="ma-0 my-3 pa-0 app-bar-header"
                        elevation="0"
                        >
                        <v-btn
                            icon
                            tile
                            small
                            color="primary"
                            class="bg-secondary-50 rounded ma-0 d-md-none"
                            @click="closeQuestionsSheet"
                        >
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            outlined
                            color="primary"
                            class="btn-comodin border-radius-1 text-transform-none font-weight-bolder"
                            @click="dialogOptions = true"
                            v-if="questions.length && !isInitialReader">
                            <v-img
                                :src="require(`@/assets/img/icons/icon-bulb.png`)"
                                height="58"
                                width="58"
                                ></v-img>
                            <span>Comodín</span>
                        </v-btn>
                    </v-app-bar>
                </div>
            </template>
            <template v-slot:content>
                <div
                    class="d-flex flex-column questions-container"
                    id="questions-container"
                    v-if="questions.length"
                >
                    <QuestionItem
                        :data="currentQuestion"
                        :cleanSelection="cleanCounter"
                        @newSelection="newSelection"
                        v-if="currentQuestion"
                        ref="questionItem"
                    />
                </div>
                <div class="d-flex flex-column questions-container" v-else>
                    <span class="text-h6 text--primary">No hay preguntas en este momento.</span>
                </div>
            </template>
            <template v-slot:actions v-if="questions.length">
                <v-row>
                    <v-col>
                        <v-btn
                            data-cy="question-nextQuestion-button"
                            color="primary"
                            black
                            block
                            large
                            class="border-radius-1 bg-gradient-primary text-lowercase font-weight-bolder font-size-16"
                            @click="evaluateQuestion"
                            v-if="showButtonForRegularStudent && showNextQuestionButton"
                            ><span class="text--white first-letter-uppercase">{{
                                $t('initialTour.next_question')
                            }}</span></v-btn
                        >
                        <v-btn
                            data-cy="question-nextQuestion-button"
                            color="primary"
                            black
                            block
                            large
                            class="border-radius-1 bg-gradient-primary text-lowercase font-weight-bolder font-size-16"
                            @click="validateQuestion"
                            v-if="showInitialReaderFlow"
                        ><span class="text--white  first-letter-uppercase">{{
                                $t('bookReading.answer')
                            }}</span></v-btn
                        >
                        <v-btn
                            data-cy="question-nextQuestion-button"
                            color="primary"
                            black
                            block
                            large
                            class="border-radius-1 bg-gradient-primary text-lowercase font-weight-bolder font-size-16"
                            @click="moveNextQuestion"
                            v-if="!showButtonForRegularStudent && showNextQuestionButton && showAdvanceNextQuestion"
                        ><span class="text--white first-letter-uppercase">{{
                                $t('initialTour.next_question')
                            }}</span></v-btn
                        >
                        <v-btn
                            data-cy="question-finishQuestions-button"
                            v-if="showButtonForRegularStudent && showSendChallengeResult && showSubmitButton"
                            :loading="resolveLoader"
                            color="primary"
                            black
                            block
                            large
                            class="border-radius-1 bg-gradient-primary text-lowercase font-weight-bolder font-size-16"
                            @click="finishChallenge"
                            ><span  class="text--white first-letter-uppercase">{{
                                $t('challenge.resolve_challenge')
                            }}</span></v-btn
                        >
                        <v-btn
                            data-cy="question-finishQuestions-button"
                            v-if="!showButtonForRegularStudent && showSendChallenge && showSubmitButton"
                            :loading="resolveLoader"
                            color="primary"
                            black
                            block
                            large
                            class="border-radius-1 bg-gradient-primary text-lowercase font-weight-bolder font-size-16"
                            @click="sendChallenge"
                        ><span  class="text--white first-letter-uppercase">{{
                                $t('challenge.resolve_challenge')
                            }}</span></v-btn
                        >
                    </v-col>
                </v-row>
            </template>
        </UtilsContent>
        <!-- <div
            :class="
                'position-absolute transition-all ' +
                (showOptions ? 'three-img-corner-button' : 'img-corner-button')
            "
            @click="showOptions = !showOptions"
            v-if="questions.length && !isInitialReader"
        ></div> -->
        <div
            class="position-absolute transition-all wildcard-button"
            v-if="showOptions"
            @click="openWildCardModal"
        ></div>
        <div
            class="position-absolute transition-all tip-button"
            @click="showTips"
            v-if="showOptions"
        ></div>
        <v-btn
            icon
            class="position-absolute transition-all cls-button"
            v-if="showOptions"
            @click="showOptions = !showOptions"
        >
            <v-icon class="text--primary">mdi-close</v-icon>
        </v-btn>
        <audio
            id="correct_audio"
            :src="global.GAMIFICATION_SOUNDS + 'answer_correct.mp3'"
            crossOrigin="anonymous"
        ></audio>
        <audio
            id="incorrect_audio"
            :src="global.GAMIFICATION_SOUNDS + 'answer_incorrect.mp3'"
            crossOrigin="anonymous"
        ></audio>
        <audio
            id="tips_audio"
            :src="global.GAMIFICATION_SOUNDS + 'question_tip_used.mp3'"
            crossOrigin="anonymous"
        ></audio>
        <audio
            id="wildcard_audio"
            :src="global.GAMIFICATION_SOUNDS + 'question_wildcard_used.mp3'"
            crossOrigin="anonymous"
        ></audio>
        <TipsModal
            v-if="currentTip"
            :dialog="showTipsModal"
            :tip_number="tipIndex + 1"
            :total_tips="tips.length"
            :tip_text="currentTip.detail"
            @close-modal="closeTipsModal"
        />
        <WildcardModal
            :dialog="showWildCardModal"
            :count_beecoins="coins"
            :wildcard_price="global.WILDCARD_PRICE"
            @close-modal="closeWildcardModal"
            @confirm="confirmBuyWildCard"
        />
        <WildcardUsedModal :dialog="showWildCardUsedModal" />
        <ChallengeSuccessModal
            :dialog.sync="showSuccessModal"
            :success="challenge_repechaje < 2"
            :pointsWon="pointsWon"
            :coinsWon="coinsWon"
            @exit-challenge="exitChallenge"
            @new-challenge="newChallenge"
        />
        <ResultMsgModal
            :dialog="showResultModal"
            :count_corrects="correctAnswers.length"
            :finish="challenge_repechaje === 2"
            @try-again="tryAgain"
            @collect-prize="collectPrize"
            @finish-action="failAction"
        />
        <FailModal :dialog="showFailModal" @continue="collectPrize" />

        <v-dialog
            content-class="shadow-none pb-8"
            overlay-color="rgb(81, 69, 133)"
            overlay-opacity=".9"
            v-model="dialogOptions"
            >
            <v-row class="ma-0">
                <!-- PISTAS -->
                <!-- <v-col cols="6" class="pr-1">
                    <div class="transition-all rotate-img" @click="showTips"
                        v-if="!isInitialReader">
                        <v-img :src="require('@/assets/img/gamifications/comodin-pistas.png')" max-width="180"></v-img>
                    </div>
                </v-col> -->
                <v-col cols="12" class="pl-1">
                    <div class="transition-all" v-if="!isInitialReader"
                        @click="openWildCardModal">
                        <v-img
                            :src="require('@/assets/img/gamifications/comodin-50.png')"
                            width="180">
                        </v-img>
                    </div>
                </v-col>
                <v-img
                    class="iconOptions"
                    :src="require(`@/assets/img/icons/icon-bulb.png`)"
                    height="100"
                    width="100"
                    ></v-img>
            </v-row>
        </v-dialog>

        <v-dialog
            content-class="shadow-none pb-8"
            overlay-color="#514585FA"
            overlay-opacity=".95"
            v-model="dialogCongratulations"
            >
            <v-img
            :src="require('@/assets/img/gamifications/icon-fist.png')"
            class="dialog-icon"
            height="80"
            width="80"
            />
            <v-card class="d-flex flex-column justify-center align-center border-radius-1">
                <div
                    class="d-flex flex-column justify-center align-center border-radius-1"
                >
                    <div class="pa-5 mx-5 mt-2">
                        <span class="text-h6 white--text pa-5 font-weight-lighter">
                            {{ $t('bookReading.congrats') }}
                        </span>
                    </div>
                    <div class="px-5 mx-5">
                        <span class="white--text text-body-1">
                            {{ $t('bookReading.congrats_questions') }}
                        </span>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState, mapActions } from 'vuex'
import global from '@/constants/GlobalConstant'
import * as Sentry from '@sentry/vue';

import {confetti} from 'dom-confetti'
import TipsModal from '@/components/reading/content/bookUtils/modals/TipsModal.vue'
import WildcardModal from '@/components/reading/content/bookUtils/modals/WildcardModal.vue'
import WildcardUsedModal from '@/components/reading/content/bookUtils/modals/WildcardUsedModal.vue'
import challengeService from '@/services/challenge'
import gamificationService from '@/services/gamification'
import initialReaderValidation from '@/mixins/InitialReaderValidation'
import Markjs from '@/mixins/Markjs'
import QuestionItem from './items/QuestionItem.vue'
import ChallengeSuccessModal from './modals/ChallengeSuccessModal.vue'
import ResultMsgModal from './modals/ResultMsgModal.vue'
import FailModal from './modals/FailModal.vue'
import UtilsContent from "../../../core/utils/UtilsContent";
import {CONFETTI_SETUP} from '../../../../constants/DefaultConstants'
import AnalyticEventsMixin from "../../../../mixins/analyticEvents"
import { AnalyticEventTypes } from '@/constants/AnalyticEventTypes'

export default {
    components: {
        UtilsContent,
        QuestionItem,
        TipsModal,
        WildcardModal,
        WildcardUsedModal,
        ChallengeSuccessModal,
        ResultMsgModal,
        FailModal,
    },
    computed: {
        ...mapState({
            questions: (state) => state.challenge.questions,
            evaluationId: (state) => state.challenge.evaluationId,
            testId: (state) => state.challenge.testId,
            tiempoEmpleadoLectura: (state) => state.challenge.tiempoEmpleadoLectura,
            tiempoEmpleadoReLectura: (state) => state.challenge.tiempoEmpleadoReLectura,
            testNuncaAplicado: (state) => state.challenge.testNuncaAplicado,
            itemsData: (state) => state.bookReading.itemsData,
            coins: (state) => state.userData.coins,
            points: (state) => state.userData.points,
            user: (state) => state.userData.user,
            tipsData: (state) => state.bookReading.tipsData,
            course: (state) => state.userData.user.course,
        }),
        showButtonForRegularStudent(){
            return !this.isInitialReader
        },
        showNextQuestionButtonForInitialReader(){
            return this.indexQuestion <= this.questions.length - 1
        },
        showNextQuestionButton(){
            return this.indexQuestion < this.questions.length - 1
        },
        showInitialReaderFlow() {
            return !this.showButtonForRegularStudent && this.showNextQuestionButtonForInitialReader && !this.showAdvanceNextQuestion && !this.showSendChallenge
        },
        showSendChallengeResult(){
            return this.indexQuestion === (this.questions.length - 1)
        },
        tips() {
            const {ordinalGrade} = this.user.course
            return this.currentQuestion ?
                this.filterByGrade(
                    this.currentQuestion.aimOfAssessmentDTO.tips,
                    ordinalGrade
                ) : []
        },
        // Anti-automation: Control button visibility based on timing
        showSubmitButton() {
            if (this.resolveLoader) return false;
            if (!this.hasMinimumTimeElapsed()) return false;
            if (!this.canSubmitChallenge()) return false;
            return true;
        },
    },
    data() {
        return {
            questionsImg: require('@/assets/img/icons/reading/3-questions.svg'),
            showOptions: false,
            secondChance: false,
            correct: false,
            asked: false,
            usedWildcard: false,
            audioCorrect: 'correct_audio',
            audioIncorrect: 'incorrect_audio',
            audioUseWildcard: 'wildcard_audio',
            audioTips: 'tips_audio',
            showTipsModal: false,
            tipIndex: -1,
            currentTip: null,
            showWildCardModal: false,
            global,
            showWildCardUsedModal: false,
            currentQuestion: null,
            indexQuestion: 0,
            answerFinish: [],
            correctAnswers: [],
            incorrectAnswers: [],
            timeToResponse: 0,
            timer: null,
            challenge_repechaje: 0,
            showSuccessModal: false,
            showResultModal: false,
            resolveLoader: false,
            showFailModal: false,
            coinsWon: 0,
            pointsWon: 0,
            selectedOption: {
                id: null,
                value: null,
                secret: null,
            },
            cleanCounter: 0,
            attempts:  1,
            showAdvanceNextQuestion: false,
            showSendChallenge: false,
            dialogOptions: false,
            dialogCongratulations: false,
            // Anti-automation properties
            questionStartTime: null,        // Timestamp cuando empieza la pregunta
            lastSubmissionTime: null,       // Timestamp del último submit exitoso
            currentTime: Date.now(),        // Para reactividad de computed properties
        }
    },
    methods: {
        ...mapActions('userData', ['setCoins', 'setPoints']),
        ...mapActions('challenge', [
            'increaseReadingTime',
            'increaseReReadingTime',
            'resetTimers',
            'clearMainTimer',
            'clearSecondaryTimer',
            'clearAllTimers',
            'setReadingTime',
            'setReReadingTime',
            'setEvaluationId',
            'ShowQuestion',
            'setQuestions',
            'setChallengeData',
            'resetChallengeState',
            'startReading',
            'pauseReading',
            'pauseReReading',
        ]),
        closeQuestion() {
            this.$emit('close-question')
        },
        closeQuestionsSheet() {
            this.$emit('close-question');
        },
        closeDialogOptions(){
            this.dialogOptions = false;
        },
        celebrateSuccess(el = null){
            if(el) confetti(el, CONFETTI_SETUP)
        },
        evaluateQuestion(){
            if (this.evaluateValue(this.selectedOption)) {
                const { secret, value } = this.selectedOption;
                this.manageObjs(value, secret);
                this.cleanOptions();
                this.nextQuestion();
            }
        },
        validateQuestion() {
            if (this.evaluateValue(this.selectedOption)) {
                const {attempts, currentQuestion} = this;
                const { mdTestPreguntaRespuestaCorrecta } = currentQuestion;
                const { secret, value } = this.selectedOption;
                this.addToAnswerFinish({
                    idPregunta: currentQuestion.id,
                    idRespuesta: value,
                    tiempoEmpleadoRespuesta: this.timeToResponse,
                    attempts
                }, false);

                if (this.isCorrect(mdTestPreguntaRespuestaCorrecta, secret)) {
                    this.setSoundEffect();
                    this.$refs.questionItem.setCorrectAnswer(this.currentQuestion.id, this.selectedOption.id );
                    this.addToCorrect(currentQuestion);
                    this.attempts = 1;
                    if (this.showSendChallengeResult) {
                        this.showSendChallenge = true;
                    } else {
                        this.showAdvanceNextQuestion = true;
                    }
                } else {
                    this.setSoundEffect(false);
                    this.$refs.questionItem.setWrongAnswer(this.currentQuestion.id, this.selectedOption.id );
                    this.increaseAttempts();
                    this.cleanOptions();
                }
            }
        },
        setSoundEffect(success = true){
            if(success){
                this.playSound(this.audioCorrect);
                this.celebrateSuccess(document.querySelector('.celebration'));
            }else {
                this.playSound(this.audioIncorrect);
            }
        },
        async sendFinishChallengeRequest() {
            let attempt = this.challenge_repechaje + 1

            this.$store.dispatch('challenge/pauseReading');
            this.$store.dispatch('challenge/pauseReReading');

            await this.$nextTick();

            let tiempoLectura = this.tiempoEmpleadoLectura || 0
            let tiempoRelectura = this.tiempoEmpleadoReLectura || 0
            const data = {
                challenge_repechaje: this.challenge_repechaje,
                attempt: attempt,
                lbUserId: this.user.id,
                mdEvaluacionId: attempt > 1 ? this.evaluationId : null,
                mdTestId: this.testId,
                testNuncaAplicado: this.testNuncaAplicado,
                tiempoEmpleadoLectura: tiempoLectura,
                tiempoEmpleadoRelectura: tiempoRelectura,
                mdTestPreguntaRespuestaFinishDTOS: this.answerFinish,
            };
            const response = await challengeService.finish(data);

            if (response.status.code === 3) {
                const errorMessage = response.content?.error === 'DUPLICATE_SUBMISSION'
                    ? this.$t('challenge.duplicate_submission_error')
                    : this.$t('general.error_msg');
                throw new Error(errorMessage);
            }

            const { content } = response;
            const { coinGanados, puntosGanados, mdEvaluacionId } = content;
            this.setEvaluationId(mdEvaluacionId);
            this.coinsWon = coinGanados;
            this.pointsWon = puntosGanados;
            this.showResultModal = true;
            this.createAnalyticEvent(AnalyticEventTypes.AnswerChallengeQuestion)
            this.$ga.event('userClick', 'answerChallengeQuestion');
            this.resolveLoader = false;
            return content;
        },
        moveNextQuestion(){
            this.cleanOptions();
            this.nextQuestion();
            this.$refs.questionItem.cleanStyles();
            this.showAdvanceNextQuestion = false
        },
        increaseAttempts(){
            this.attempts += 1
        },
        manageObjs(value, secret) {
            const {attempts, currentQuestion} = this;
            const { mdTestPreguntaRespuestaCorrecta } = currentQuestion;
            this.addToAnswerFinish({
                idPregunta: currentQuestion.id,
                idRespuesta: value,
                tiempoEmpleadoRespuesta: this.timeToResponse,
                attempts
            });
            if (this.isCorrect(mdTestPreguntaRespuestaCorrecta, secret)) {
                this.addToCorrect(currentQuestion)
            } else {
                this.addToIncorrect(currentQuestion)
            }
        },
        isCorrect({item = null}, secret = null){
            return item ? item === parseInt(secret, 10): false
        },
        newSelection(selectionParam) {
            this.selectedOption = selectionParam
        },
        nextQuestion() {
            this.indexQuestion += 1
            this.currentQuestion = this.questions.at(this.indexQuestion)
            this.timeToResponse = 0
            this.tipIndex = -1
            this.usedWildcard = false
            // Anti-automation: Reset question start time
            this.questionStartTime = Date.now()
        },
        filterByGrade(tips, grade) {
            const result = []
            tips.forEach((tip) => {
                if (tip.educationLevel === 'ALL') {
                    result.push(tip)
                }

                if (grade >= 1 && grade <= 6 && tip.educationLevel === 'PRIMARY') {
                    result.push(tip)
                }

                if (grade >= 7 && grade <= 12 && tip.educationLevel === 'SECONDARY') {
                    result.push(tip)
                }
            })
            return result
        },
        async sendChallenge(){
            // Anti-automation: Check cooldown
            if (!this.canSubmitChallenge()) {
                console.warn('Anti-automation: Cooldown activo');
                return;
            }

            try {
                this.resolveLoader = true;
                await this.sendFinishChallengeRequest();
                // Anti-automation: Track submission time
                this.lastSubmissionTime = Date.now();
            } catch (error) {
                Sentry.captureException(error);
                this.$modal.error(error.message)
            }
        },
        async finishChallenge() {
            // Anti-automation: Check minimum time and cooldown
            if (!this.hasMinimumTimeElapsed() || !this.canSubmitChallenge()) {
                console.warn('Anti-automation: Acción bloqueada');
                return;
            }

            try {
                this.resolveLoader = true;
                const value = this.evaluateValue(this.selectedOption);
                if (value) {
                    const {secret} = this.selectedOption;
                    this.manageObjs(value, secret);
                    await this.sendFinishChallengeRequest();
                    // Anti-automation: Track submission time
                    this.lastSubmissionTime = Date.now();
                }
            } catch (error) {
                Sentry.captureException(error);
                this.$modal.error(error.message);
            } finally {
                this.resolveLoader = false;
            }
        },
        addToAnswerFinish(object, findExistingObject = true) {
            if (this.answerFinish.length && findExistingObject) {
                const found = this.answerFinish.find((el) => el.idPregunta === object.idPregunta);
                if (!found) this.answerFinish = [...this.answerFinish, object];
                else this.answerFinish[this.answerFinish.indexOf(found)] = object;
            } else {
                this.answerFinish = [...this.answerFinish, object];
            }
        },
        addToCorrect(obj) {
            if (this.correctAnswers.length) {
                const found = this.correctAnswers.find((el) => el.id === obj.id);
                const foundIncorrect = this.incorrectAnswers.find((el) => el.id === obj.id);

                if (!found) this.correctAnswers = [...this.correctAnswers, obj];
                else this.correctAnswers[this.correctAnswers.indexOf(found)] = obj;

                if (foundIncorrect)
                    this.incorrectAnswers.splice(this.incorrectAnswers.indexOf(foundIncorrect), 1)
            } else {
                this.correctAnswers = [...this.correctAnswers, obj]
            }
        },
        addToIncorrect(obj) {
            if (this.incorrectAnswers.length) {
                const found = this.incorrectAnswers.find((el) => el.id === obj.id);

                if (!found) this.incorrectAnswers = [...this.incorrectAnswers, obj];
                else this.incorrectAnswers[this.incorrectAnswers.indexOf(found)] = obj;

            } else {
                this.incorrectAnswers = [...this.incorrectAnswers, obj]
            }
        },
        evaluateValue({id = 0, value = null}) {
            if (id) return value;
            this.$modal.error(this.$t('initialTour.select_option'));
            return false;
        },
        tryAgain() {
            this.cleanOptions()
            if (this.incorrectAnswers.length) {
                this.challenge_repechaje += 1
                this.indexQuestion = 0
                const arrTemp = [...this.incorrectAnswers]
                this.setQuestions(arrTemp)
                this.currentQuestion = this.questions.at(this.indexQuestion)
                this.incorrectAnswers = []
            }
            this.ShowQuestion()
            this.resetTimers()
            this.startReading()
            this.showResultModal = false
            this.resolveLoader = false
        },
        collectPrize() {
            this.showResultModal = false
            this.resolveLoader = false
            this.showFailModal = false
            this.showSuccessModal = true
            this.usedWildcard = false
            this.setCoins(this.coins + this.coinsWon)
            this.setPoints(this.points + this.pointsWon)
            this.celebrateSuccess(document.getElementById('success-modal'))
        },
        async newChallenge() {
            if (!this.isInitialReader) {
                this.$loading(true);
                this.showSuccessModal = false;
                this.showResultModal = false;
                this.showFailModal = false;
                await this.removeChallengeAudio();
                this.cleanOptions();
                this.ShowQuestion();
                this.currentQuestion = null;
                this.indexQuestion = 0;
                const { content } = await challengeService.initTest(this.user.id, false, this.isInitialReader)
                this.resetChallengeState();
                this.resetTimers();
                this.setChallengeData(content);
                this.startReading();
                this.currentQuestion = this.questions.at(this.indexQuestion);
                this.correctAnswers = [];
                this.incorrectAnswers = [];
                this.answerFinish = [];
                this.challenge_repechaje = 0;
                this.$loading(false);

                // Hacer scroll al top del contenedor de preguntas
                this.$nextTick(() => {
                    this.scrollToTop();
                });
            } else this.$router.go(0)
        },
        exitChallenge() {
            this.resetChallengeState()
            this.$router.go(-1)
        },
        failAction() {
            this.showResultModal = false
            this.showFailModal = true
        },
        cleanOptions() {
            this.selectedOption = {
                id: null,
                value: null,
                secret: null,
            };
            this.cleanCounter += 1;
            document.querySelectorAll('.hide-option').forEach((el) => {
                el.classList.toggle('hide-option')
            })
        },
        // get audio element, set volume to '0.4' and play
        playSound(player) {
            const playerElement = document.getElementById(player)
            if (playerElement) {
                playerElement.volume = 0.4;
                playerElement.play()
            }
        },
        showTips() {
            this.tipIndex += 1
            if (this.tipIndex <= this.tips.length - 1) {
                this.playSound(this.audioTips)
                this.currentTip = this.tips.at(this.tipIndex)
                this.showTipsModal = true
                this.showOptions = false
                return
            }
            this.showOptions = false
            this.showTipsModal = false
            this.$modal.warning('Ya has utilizado todas las pistas para esta pregunta. Relee el texto para ayudarte a responder.')
        },
        closeTipsModal() {
            this.showTipsModal = false
            this.showOptions = false
        },
        closeWildcardModal() {
            this.showWildCardModal = false
            this.usedWildcard = false
        },
        pickRandomFromRange(min, max, exclude = null) {
            const result = Math.floor(Math.random() * (max - min + 1) + min)
            if (exclude && result === exclude) {
                return this.pickRandomFromRange(min, max, exclude)
            }
            return result
        },
        confirmBuyWildCard() {
            if (this.coins < this.global.WILDCARD_PRICE) {
                this.$modal.error(this.$t('bookReading.without_beecoins'))
                return
            }
            const vm = this
            gamificationService
                .confirmAction(this.user.id, this.global.WILDCARD_PRICE)
                .catch((error) => console.error(error))
            this.playSound(this.audioUseWildcard)
            this.setCoins(this.coins - this.global.WILDCARD_PRICE)
            const currentQuestion = this.questions[this.indexQuestion]
            const randomItemToExclude = this.pickRandomFromRange(1, 4, currentQuestion.mdTestPreguntaRespuestaCorrecta.item)
            const optionsToHide = currentQuestion.mdTestPreguntaRespuestases.filter(
                (answer) => answer.id !== currentQuestion.mdTestPreguntaRespuestaCorrecta.id
                && answer.item !== randomItemToExclude
            )
            optionsToHide.forEach((opt, index) => {
                if (index === 1 || index === 0) {
                    const el = document.getElementById(opt.id)
                    const prev = el.previousElementSibling
                    if (el) el.classList.toggle('hide-option')
                    if (prev) prev.classList.toggle('hide-option')
                }
            })
            this.usedWildcard = true
            this.showOptions = false
            this.showWildCardModal = false
            this.showWildCardUsedModal = true
            setTimeout(() => {
                vm.showWildCardUsedModal = false
            }, 1000)
        },
        openWildCardModal() {
            if (this.usedWildcard) {
                this.$modal.error(this.$t('bookReading.wildcard_alredy_use'))
                return
            }
            this.showWildCardModal = true
            this.showOptions = false
        },
        // Anti-automation: Check if minimum time elapsed since question started
        hasMinimumTimeElapsed() {
            if (!this.questionStartTime) return true;
            const elapsed = this.currentTime - this.questionStartTime;
            return elapsed >= this.global.MIN_QUESTION_TIME;
        },
        // Anti-automation: Check if cooldown period has passed since last submission
        canSubmitChallenge() {
            if (!this.lastSubmissionTime) return true;
            const elapsed = this.currentTime - this.lastSubmissionTime;
            return elapsed >= this.global.MIN_CHALLENGE_COOLDOWN;
        },
        increaseTime() {
            this.timeToResponse += 1
        },
        scrollToTop() {
            // Hacer scroll al top del contenedor de preguntas
            const questionsContainer = document.getElementById('questions-container');
            if (questionsContainer) {
                questionsContainer.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }

            // También hacer scroll al top de la ventana como alternativa
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
    },
    mixins: [initialReaderValidation, Markjs, AnalyticEventsMixin],
    mounted() {
        const vm = this
        this.currentQuestion = this.questions.at(this.indexQuestion)

        // Anti-automation: Initialize question start time
        this.questionStartTime = Date.now()

        // Anti-automation: Update currentTime for reactive computed properties
        setInterval(() => {
            vm.currentTime = Date.now()
        }, 100)

        this.timer = setInterval(() => {
            vm.increaseTime()
        }, 1000)

        // get wildcard close modal
        this.$root.$on('dialogOptions', this.closeDialogOptions)
    },
}
</script>
<style>
.questions-container {
    max-height: 70vh;
    max-width: 100%;
    overflow: auto;
}

.img-corner-button {
    background: url(../../../../assets/img/gamifications/comodin-001.svg) round;
    z-index: 11;
}

.img-corner-button:hover {
    background: url(../../../../assets/img/gamifications/comodin-003.svg) round;
    cursor: pointer;
}
.three-img-corner-button {
    background: url(../../../../assets/img/gamifications/comodin-004.svg) round;
    cursor: pointer;
    z-index: 11;
}

.wildcard-button {
    background: url(../../../../assets/img/gamifications/50-50.svg) round;
    cursor: pointer;
    z-index: 11;
}

.tip-button {
    background: url(../../../../assets/img/gamifications/pistas.svg) round;
    cursor: pointer;
    z-index: 11;
}

.cls-button {
    z-index: 11;
    bottom: 17.5vh;
    left: 1vh;
}

.wildcard-button:hover,
.tip-button:hover {
    bottom: 2.5em;
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .img-corner-button {
        bottom: -10vh;
        left: -10vh;
        z-index: 11;
        width: 25vh;
        height: 25vh;
        padding: 8vh;
    }

    .img-corner-button:hover {
        bottom: -10vh;
        left: -10vh;
        width: 25vh;
        height: 25vh;
        padding: 8vh;
    }
    .three-img-corner-button {
        bottom: -10vh;
        left: -10vh;
        width: 25vh;
        height: 25vh;
        padding: 8vh;
    }

    .wildcard-button {
        bottom: 2vh;
        left: 0vh;
        z-index: 11;
        width: 18vh;
        height: 18vh;
    }

    .tip-button {
        bottom: 2vh;
        left: -14vh;
        z-index: 11;
        width: 18vh;
        height: 20vh;
    }

    .wildcard-button:hover,
    .tip-button:hover {
        bottom: 2.5vh;
    }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
    .questions-container {
        max-height: 55vh;
        overflow: auto;
    }

    .img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        padding: 11.5vh;
    }

    .img-corner-button:hover {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        padding: 11.5vh;
    }
    .three-img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        padding: 11.5vh;
    }

    .wildcard-button {
        bottom: 2vh;
        left: -2.5vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
    }

    .tip-button {
        bottom: 2vh;
        left: -15vh;
        z-index: 11;
        width: 15vh;
        height: 16.5vh;
    }

    .wildcard-button:hover,
    .tip-button:hover {
        bottom: 2.5vh;
    }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    .questions-container {
        max-height: 70vh;
        overflow: auto;
    }
    .img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 22.5vh;
        height: 22.5vh;
        padding: 10vh;
    }

    .img-corner-button:hover {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 22.5vh;
        height: 22.5vh;
        padding: 10vh;
    }
    .three-img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 22.5vh;
        height: 22.5vh;
        cursor: pointer;
        padding: 10vh;
    }

    .wildcard-button {
        bottom: 2vh;
        left: 1vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        cursor: pointer;
    }

    .tip-button {
        bottom: 2vh;
        left: -9vh;
        z-index: 11;
        width: 12vh;
        height: 16vh;
        cursor: pointer;
    }

    .wildcard-button:hover,
    .tip-button:hover {
        bottom: 3.5vh;
    }
}

.hide-option {
    display: none !important;
    clear: both;
}
</style>
